import React, { useMemo, useState, useEffect } from "react";

import DataTable from "react-data-table-component";
import FilterComponent from "./FilterComponent";
import axios from 'axios'
import { API_BASE_PATH, post } from "../Api";
import { FaCheck, FaCheckCircle, FaEye, FaPause, FaPlay, FaStop, FaTimes, FaTimesCircle } from "react-icons/fa";
import { Button, ButtonGroup, Icon, useColorModeValue } from "@chakra-ui/react";
import { Filter, Play, StopCircle } from "lucide-react";

const FILTERS = [
  { id: "all",   label: "All",   icon: Filter },
  { id: "start", label: "Start", icon: Play },
  { id: "stop",  label: "Stop",  icon: StopCircle },
];

const OneDRideAccountTable = props => {
    const columns = [
        {
            name: "Username",
            selector: "id",
            sortable: true,
            cell: row =>
            (
                <>
                    <div className="flex gap-1" style={{textDecoration:"underline",cursor:"pointer",fontSize:"11px"}}  
                        onClick={() => window.open("/map/livemapsingle.html?id=zrider_instance_"+encodeURIComponent(row.phone),"livemap")}
            ><FaEye className="w-3 h-3"></FaEye>{row.username}</div>
                </>
            ) 
            
        },
{
        name: "Name",
        selector: "name",
        sortable: true,
        
    },
        {
            name: "Vehicle Number",
            selector: "vehicleNumber",
            sortable: true,
            
        },
       
        {
            name: "Location",
            selector: "city",
            sortable: true,
            
        },
        {
            name: "Vehicle Type",
            selector: "vehicleType",
            sortable: true,
            
        },
        {
            name: "Vehicle Images",
            selector: "vehicleImageURL",
            sortable: true,
            cell: row =>
            (
                <div className="flex gap-1 pr-4">
                    <img style={{aspectRatio:"1/1", width:"50px",height:"50px",objectFit:"cover",borderRadius:"50%"}} src={row.vehicleImageURL}/>
                    <img style={{aspectRatio:"1/1",width:"50px",height:"50px",objectFit:"cover",borderRadius:"50%"}} src={row.driverImageURL}/>

                </div>
            ) 
            
        },
       
        // {
        //     name: "Phone",
        //     selector: "phone",
        //     sortable: true,
            
        // },
        
        {
            name: "Subs Status",
            selector: "subsStatus",
            sortable: true,
            cell: row =>
            (
                <>
                    {row.subsStatus?"Active":"Inactive"}
                      
                </>
            ) 
            
        },
        {
            name: "Operation Status",
            selector: "operationStatus",
            sortable: true,
            cell: row =>
            (
                <>
                   {row.operationStatus=="start"?<FaCheckCircle color="green"></FaCheckCircle>:<FaTimesCircle color="red"></FaTimesCircle>} { (row.operationStatus||'stop').toUpperCase()}
                      
                </>
            ) 
            
        },
        {
            name: "Last Updated",
            selector: "lastAccessDate",
            sortable: true,
            cell: row =>
                (
                    <>
                       {new Date(+(row.time||row.lastAccessDate)).toLocaleString()}
                    </>
                ) 
            
        },
        {
            name: "  Buttons  ",
            button: true,
            width: "140px" ,    
            cell: row =>
                (
                    <>
                        <button
                            className="btn btn-primary btn-sm shadow-lg m-0"
                            onClick={() => props.onSelectRecord(row)}
                            style={{ marginRight: "0px",background:"black",marginRight:"2px",borderRadius:"20px"}}
                        >Details</button>
                    </>
                ) 
        }
    ];
    const [data, setData] = useState([]);
    const [filterText, setFilterText] = React.useState("");
    const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
        false
    );
    const filteredItems = data;
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [stateFilter, setStateFilter] = useState("all");

    var userInfo = localStorage.getItem("userInfo");
    if (userInfo) {
        userInfo = JSON.parse(userInfo);
    }
    
    const onDataFilter=val=>{
        setFilterText(val);
        fetchUsers(1,val);
    }

    useEffect(()=>{
        if(stateFilter){
            fetchUsers(1,filterText);
        }
    },[stateFilter])


    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                onDataFilter("");
            }
        };

        return (
            <FilterComponent
                onFilter={e => onDataFilter(e.target.value)}
                onFilterText={e => onDataFilter(filterText)}
                onSaveFilter={e => setFilterText(e.target.value)}
                onClear={handleClear}
                filterText={filterText}
            />
        );
    }, [filterText, resetPaginationToggle]);

   

    const fetchDataOC=async (page,filter) =>{

        var multiFilter ={
            "condition":"AND",
            "rules":[
              {
                "field": "vehicleNumber",
                "type": "string",
                "operator": "!=",
                "value": ""
              },
              {
                "field": "role",
                "type": "string",
                "operator": "=",
                "value": "user"
              }
            ]
          }

          if(stateFilter && stateFilter!="all"){
            multiFilter.rules.push({
                "field": "operationStatus",
                "type": "string",
                "operator": "=",
                "value": stateFilter
            })
          }

          
        const filt = filter?{searchFilter:{
            vehicleNumber:filter,
            phone:filter,
            name:filter,

            multiFilter:multiFilter
        }}:{role:"user",multiFilter:multiFilter}
        const response = await post(`/objects/zrider_account/search?partnerId=${userInfo.partnerId}&count=10&offset=${(page-1)*10}&order=lastaccessdate&dir=desc`,filt);
        setData(response.rows.map(s=>{
            s.data.id=s.dataKey;
            s.data.lastAccessDate=s.lastAccessDate;

            return s.data;
        }));
        let count = response.total;
        
        setTotalRows(count);
        return response.data;
    }

    const fetchUsers = async (page,filt) => {
        setLoading(true);
        await fetchDataOC(page,filt);

        setPerPage(10);
        setLoading(false);
    };

    const handlePageChange = page => {
        fetchUsers(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        // setLoading(true);
        // const response = await axios.get(`/objects/outletClusters?lob=${userInfo.accountId}&page=${page}&count=${newPerPage}&resolve=true`);
        // setData(response.data.data);
        // setTotalRows(response.data.length+100);
        // //setPerPage(newPerPage);
        // setLoading(false);
    };

    useEffect(() => {
        // alert("Calling")

        fetchUsers(1); // fetch page 1 of users
    }, [props.updateTime]);

   function FilterButtons({ value = "all", onChange, size = "sm" }) {
        const activeBg   = useColorModeValue("teal.500", "teal.300");
        const activeText = useColorModeValue("white", "gray.800");
      
        return (
          <ButtonGroup className="mt-2" isAttached variant="outline" size={size}>
            {FILTERS.map(({ id, label, icon }) => {
              const isActive = id === value;
              return (
                <Button
                  key={id}
                  leftIcon={<Icon as={icon} boxSize={4} />}
                  borderRadius="full"
                  bg={isActive ? activeBg   : undefined}
                  color={isActive ? activeText : undefined}
                  _hover={{ bg: isActive ? activeBg : "gray.100" }}
                  _dark={{ _hover: { bg: isActive ? activeBg : "gray.700" } }}
                  onClick={() => onChange?.(id)}
                >
                  {label}
                </Button>
              );
            })}
          </ButtonGroup>
        );
      }

     
    return (
      <><FilterButtons value={stateFilter} onChange={setStateFilter} size="sm"></FilterButtons>  <DataTable
            
            title=""
            columns={columns}
            data={filteredItems}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponent}
        /></>
    );
};




export default OneDRideAccountTable;
